import { Button, Group } from "@mantine/core";
import { useTranslation } from "react-i18next";

import classes from "../../../UserProfile.module.css";

import { Modal, TextSerif } from "@/components/elements";

import type { FC } from "react";

interface Props {
  isOpen: boolean;
  closeConfirm: () => void;
  onConfirm: () => void;
  isPending?: boolean;
}

export const DeleteAccountConfirmModal: FC<Props> = ({
  isOpen,
  closeConfirm,
  onConfirm,
  isPending,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      opened={isOpen}
      onClose={closeConfirm}
      title="Delete Carburate Account"
      centered
      size="md"
      closeOnClickOutside={!isPending}
      closeOnEscape={!isPending}
    >
      <TextSerif size="md" c="gray" fz="1.06em" lh="xs">
        {t("profile.delete_account.delete_warning")}
      </TextSerif>

      <Group justify="space-between" wrap="nowrap" gap="sm" mt="lg" p="md">
        <Button
          bg="red"
          fw={600}
          onClick={onConfirm} // This function will confirm the account deletion
          loading={isPending}
          disabled={isPending}
          fullWidth
          className={classes.buttonDeleteAccount}
          aria-label={t("profile.delete_account.delete_my_account")}
        >
          {t("profile.delete_account.delete_my_account")}
        </Button>
      </Group>
    </Modal>
  );
};
